import React, { useEffect } from 'react';
import './App.scss';
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import DashboardPage from './pages/dashboard/DashboardPage';
import PlanDetailsPage from './pages/planDetails/PlanDetailsPage';
import PlansPage from './pages/plans/PlansPage';
import HeaderComponent from './components/Header/HeaderComponent';

function AppRoutes() {
	const navigate = useNavigate();

	useEffect(() => {
		if (performance.navigation.type === 1) {
			// Full page reload
			navigate('/', { replace: true });
		}
	}, []);

	return (
		<>
			<HeaderComponent />
			<Routes>
				<Route path='/' element={<DashboardPage />} />
				<Route path="/plans" element={<PlansPage />} />
				<Route path="/plan/:id" element={<PlanDetailsPage />} />
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</>
	);
}

function App() {
	return (
		<BrowserRouter>
			<AppRoutes />
		</BrowserRouter>
	);
}

export default App;
